import React from "react";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";

import InputFile from "../../Common/InputFile";
import CustomButton from "../../Common/CustomButton";
import CloseIcon from "../../Common/CloseIcon";

import { DATA_POLICY } from "../../../constants/profiles";

const AddPhotos = (props) => {
  const {
    photos,
    setPhotos,
    savePhotos,
    close,
    classes,
    setStep,
    onlySave = false,
  } = props;

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      style={{ height: "100%" }}
      wrap="nowrap"
    >
      <Grid item>
        <Grid container direction="row-reverse">
          <Grid item className={classes.closeBtn}>
            <CloseIcon closeFunction={close} />
          </Grid>
          <Grid item xs />
        </Grid>
      </Grid>
      <Grid item xs style={{ padding: "0px 35px 24px" }}>
        <Grid container direction="column" alignItems="center">
          <Grid
            item
            className="text-54 text-center bold-500"
            style={{ textTransform: "uppercase" }}
          >
            {I18n.get("profiles_addPhotos")}
          </Grid>
          <Grid item style={{ margin: "24px 0px 38px 0px" }}>
            <InputFile photos={photos} setPhotos={setPhotos} />
          </Grid>
          {onlySave ? (
            <Grid item className={classes.postCreationBtn}>
              <CustomButton
                variant="contained"
                color="primary"
                onClick={savePhotos}
                disabled={photos.length === 0}
                style={{ marginRight: "10px", marginLeft: "10px" }}
              >
                {I18n.get("site_save")}
              </CustomButton>
            </Grid>
          ) : (
            <>
              <Grid item className={classes.postCreationBtn}>
                <CustomButton
                  variant="contained"
                  color="primary"
                  onClick={() => setStep(DATA_POLICY)}
                  disabled={photos.length === 0}
                  style={{ marginRight: "10px" }}
                >
                  {I18n.get("profiles_enroll")}
                </CustomButton>
              </Grid>
              <Grid item className={classes.postCreationBtn}>
                <CustomButton
                  color="primary"
                  onClick={savePhotos}
                  disabled={photos.length === 0}
                >
                  {I18n.get("profiles_saveWithoutEnrolling")}
                </CustomButton>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

AddPhotos.propTypes = {
  photos: PropTypes.array.isRequired,
  setPhotos: PropTypes.func.isRequired,
  savePhotos: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  setStep: PropTypes.func,
  onlySave: PropTypes.bool,
};

export default AddPhotos;
